import type { Map } from "ol";
import { getGeoMarkerLayer } from "../../layers";
import { fromLonLat } from "ol/proj";
import { containsCoordinate } from "ol/extent";
import { formatExtent } from "../../helpers";
import { store } from "../../../../../stateManagement/store";
import { setShowUserLocationButtonIsClicked } from "../../../../../stateManagement/reducers/ContentHeaderSlice";
import { showToastMessage } from "../../../../../stateManagement/reducers";

//Перемещение на местоположение браузера
export function activateShowUserLocationFunction(showUserLocationButtonIsClicked: boolean, localExtent: any, map?: Map) {
    const geoMarkerLayer = getGeoMarkerLayer();
    if (showUserLocationButtonIsClicked) {
        map?.addLayer(geoMarkerLayer)
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const coordinates = fromLonLat([
                    position.coords.longitude,
                    position.coords.latitude,
                ]);
                let extent: any = formatExtent(localExtent)
                if (containsCoordinate(extent, coordinates)) {
                    geoMarkerLayer?.getSource()?.getFeatures()[0]?.getGeometry()?.setCoordinates(coordinates);
                    map?.getView().setCenter(coordinates);
                    map?.getView().setZoom(14);
                } else {
                    store.dispatch(showToastMessage({messageText: 'Ваше местоположение находится вне зоны используемого сервера', messageType: "error", windowType: "map"}))
                    store.dispatch(setShowUserLocationButtonIsClicked(false))
                }
            },
            (error) => {
                console.error("Возникла ошибка во время запроса текущей геопозиции:", error);
                store.dispatch(showToastMessage({messageText: 'Возникла ошибка во время запроса текущей геопозиции. Проверьте, что браузеру доступна информация о вашем местоположении', messageType: "error", windowType: "map"}))
                store.dispatch(setShowUserLocationButtonIsClicked(false))
            },
            { enableHighAccuracy: true }
        );
    }
    return {
        off: () => {
            map?.removeLayer(geoMarkerLayer);
        }
    };
}